export default "__VITE_ASSET__s1Rsp3Pv__"